module.exports = __webpack_public_path__ + "static/media/gis_logo.ce952181.svg";